import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import Iconify from '../../../../components/Iconify';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { ColorPicker } from '../../../../components/ColorPicker';

export const ManageRelatedOrdersGroupDialog = props => {
  const { open, setOpen, order, orders, setOrders, houseOrders, setHouseOrders, nodes } = props;
  const { updateNodesF, handleRelatedGroups } = useAccomodationDiagram();
  const options = houseOrders ? houseOrders.filter(o => {
    if (!order.relatedGroup) {
      return o.id !== order.id;
    }

    return true;
  }).filter(o => !o.relatedGroup && o.participant_gender == order.participant_gender)
    .map(o => `${o.participant_name} - ${o.identifier}`) : orders.filter(o => {
    if (!order.relatedGroup) {
      return o.id !== order.id;
    }

    return true;
  }).filter(o => !o.relatedGroup && o.participant_gender == order.participant_gender)
    .map(o => `${o.participant_name} - ${o.identifier}`);
  const relatedGroup = order.relatedGroup;
  const [selectedOrders, setSelectedOrders] = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');
  const [ordersToRemoveRelatedGroup, setOrdersToRemoveRelatedGroup] = React.useState([]);
  const [selectedColor, setSelectedColor] = React.useState(order.relatedGroup.color); // Domyślny kolor

  const handleColorChange = color => {
    const newColor = color.hex; // Nowy kolor z inputu
    setSelectedColor(newColor); // Ustaw nowy kolor
  };

  const onSubmit = () => {
    const identifiers = [];
    const identifiersToRemove = [];
    for (const o of selectedOrders) {
      const identifier = o.split(' - ');
      identifiers.push(identifier.at(-1));
    }
    for (const o of ordersToRemoveRelatedGroup) {
      const identifier = o.split(' - ');
      identifiersToRemove.push(identifier.at(-1));
    }
    handleRelatedGroup(identifiers, identifiersToRemove);
  };

  const handleRelatedGroup = (identifiers, identifiersToRemove) => {
    if (houseOrders) {
      // Strategia zarządzania grupą z poziomu diagramu
      const newNodes = nodes.map(n => {
        if (identifiersToRemove.includes(n.data?.order?.identifier)) {
          const updatedNode = {
            ...n,
            data: {
              ...n.data,
              order: {
                ...n.data.order
              }
            }
          };
          Reflect.deleteProperty(updatedNode.data.order, 'relatedGroup');

          return updatedNode;
        }

        return n;
      });
      const finalNodes = newNodes.map(n => {
        if (identifiers.includes(n.data?.order?.identifier)) {
          const updatedNode = {
            ...n,
            data: {
              ...n.data,
              order: {
                ...n.data.order,
                relatedGroup: { ...relatedGroup, color: selectedColor }
              }
            }
          };

          return updatedNode;
        }

        return n;
      });
      updateNodesF(finalNodes);
      handleRelatedGroups(null, finalNodes);
    } else {
      // Strategia zarządzania grupą z poziomu listy zamówień
      const newOrders = orders;
      // Najpierw usuwamy, potem ewentualnie dodajemy na nowo, jeśli order jest w obydwu listach
      newOrders.map(o => {
        if (identifiersToRemove.includes(o.identifier)) {
          Reflect.deleteProperty(o, 'relatedGroup');
        }
      });
      newOrders.map(o => {
        if (identifiers.includes(o.identifier)) {
          o.relatedGroup = { ...relatedGroup, color: selectedColor };
        }
      });
      // const groupedOrders = groupOrders(newOrders);
      setOrders(newOrders);
      handleRelatedGroups(newOrders);
    }
    setHouseOrders(null);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setHouseOrders(null);
  };

  React.useEffect(() => {
    if (order.relatedGroup) {
      if (houseOrders) {
        setSelectedOrders(nodes.filter(n => n.data?.order?.relatedGroup?.id == order.relatedGroup.id).map(n => `${n.data.order.participant_name} - ${n.data.order.identifier}`));
      } else {
        setSelectedOrders(orders.filter(o => o.relatedGroup && o.relatedGroup.id == order.relatedGroup.id).map(o => `${o.participant_name} - ${o.identifier}`));
      }
    }
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle id="add-new-house-dialog">Powiąż zamówienia</DialogTitle>
      <DialogContent>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Lista dostępnych zamówień</Typography>
          <Autocomplete
            multiple // Dodano prop multiple dla wielokrotnego wyboru
            value={selectedOrders}
            onChange={(event, newValue) => {
              // Obsługa usuwania lub dodawania elementów
              if (newValue.length < selectedOrders.length) {
                const removedItem = selectedOrders.find(item => !newValue.includes(item));
                setOrdersToRemoveRelatedGroup(prev => [...prev, removedItem]);
              }

              setSelectedOrders(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            id="controllable-states-demo"
            options={options}
            sx={{ width: 400 }}
            renderInput={params => <TextField {...params} label="Wybierz zamówienia" />}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Wybierz kolor grupy</Typography>
          <ColorPicker color={selectedColor} handleColorChange={handleColorChange} width="70%" />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button
            fullWidth
            variant="contained"
            endIcon={<Iconify icon={'eva:save-fill'} />}
            onClick={onSubmit}
          >
            Zapisz zmiany
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
